import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'state-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex-align-items-center justify-content-center">
      <span class="text-details" (click)="onCellClick(rowData)">
        {{ rowData.stateName || rowData.state}}
      </span>
    </div>
  `,
  styles: [
    `
      .text-details {
        font-family: var(--manrope);
        font-size: 16px;
        font-weight: 500;
        line-height: 21.86px;
        color: var(--brand-primary);
        cursor: pointer;
      }
    `,
  ],
})
export class StateCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
  onCellClick(rowData: any) {
    let state=rowData.state|| rowData.stateName
    this.cellClick.emit(state);
  }
}
